import type { RouteRecordRaw } from "vue-router";

export const textEditorRoutes: RouteRecordRaw[] = [
  {
    path: "/text_editor/info",
    name: "text_editor-info",
    component: () => import("./info/TextEditorInfoPage.vue"),
    meta: {
      namespace: "text_editor",
      title: "tools_meta.text_editor_prefix",
    },
  },
  {
    path: "/text_editor/documents",
    name: "text_editor-index",
    component: () => import("./documents/DocumentListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "text_editor",
      title: "tools_meta.text_editor_prefix",
    },
  },
  {
    path: "/text_editor/documents/:id",
    name: "text_editor-show",
    component: () => import("./documents/DocumentLayout.vue"),
    meta: {
      namespace: "text_editor",
      title: "tools_meta.text_editor_prefix",
    },
    children: [
      {
        path: "settings",
        name: "text_editor-settings",
        component: () => import("./documents/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "text_editor",
          title: "tools_meta.text_editor_prefix",
        },
      },
      {
        path: "share",
        name: "text_editor-share",
        component: () => import("./documents/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "text_editor",
          title: "tools_meta.text_editor_prefix",
        },
      },
    ],
  },
  {
    path: "/text_editor/public_documents/:id",
    name: "text_editor-public-show",
    component: () => import("./public_documents/PublicDocumentPage.vue"),
    meta: {
      namespace: "text_editor",
      title: "tools_meta.text_editor_prefix",
    },
    children: [
      {
        path: "settings",
        name: "text_editor-public-settings",
        component: () => import("./public_documents/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "text_editor",
          title: "tools_meta.text_editor_prefix",
        },
      },
    ],
  },
];
